import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Integrations from './screens';

const IntegrationRoutes = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route exact path={`${path}/`}>
          <Integrations />
        </Route>
        <Route path={`${path}/freshdeskcustomersuccess`}>
          <div>{t('settings.integration.options.freshdesk')}</div>
        </Route>
        <Route path={`${path}/freshdesksupportdesk`}>
          <div>{t('settings.integration.options.freshdesk_support')}</div>
        </Route>
        <Route path={`${path}/freshdeskmessaging`}>
          <div>{t('settings.integration.options.freshdesk_messaging')}</div>
        </Route>
        <Route path={`${path}/freshservice`}>
          <div>{t('settings.integration.options.freshservice')}</div>
        </Route>
        <Route path={`${path}/freshsalessuite`}>
          <div>{t('settings.integration.options.freshsales_suite')}</div>
        </Route>
        <Route path={`${path}/slack`}>
          <div>{t('settings.integration.options.slack')}</div>
        </Route>
        <Route path={`${path}/teams`}>
          <div>{t('settings.integration.options.microsoft_teams')}</div>
        </Route>
      </Switch>
    </>
  );
};

export default IntegrationRoutes;
